import React from 'react';
import { node, string } from 'prop-types';
import classNames from 'classnames';
import { Field } from 'react-final-form';

import css from './FieldRadioButton.module.css';

const IconRadioButton = props => {
  const { checkedClassName, isCheckBoxStyle } = props;
  return (
    <div>
      {isCheckBoxStyle ? <div>
        <svg className={css.checked} width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
          <g filter="url(#filter0_i_3405_4872)">
            <rect width="22" height="22" rx="2" fill="white" />
          </g>
          <g clipPath="url(#clip0_3405_4872)">
            <path fillRule="evenodd" clipRule="evenodd" d="M17.3643 6.40732C17.5518 6.59484 17.6571 6.84915 17.6571 7.11432C17.6571 7.37948 17.5518 7.63379 17.3643 7.82132L9.86901 15.3166C9.76996 15.4157 9.65236 15.4943 9.52293 15.5479C9.3935 15.6016 9.25477 15.6292 9.11468 15.6292C8.97458 15.6292 8.83585 15.6016 8.70642 15.5479C8.57699 15.4943 8.4594 15.4157 8.36034 15.3166L4.63634 11.5933C4.54083 11.5011 4.46465 11.3907 4.41224 11.2687C4.35983 11.1467 4.33225 11.0155 4.33109 10.8827C4.32994 10.7499 4.35524 10.6183 4.40552 10.4954C4.4558 10.3725 4.53006 10.2608 4.62395 10.1669C4.71784 10.073 4.82949 9.99878 4.95239 9.94849C5.07529 9.89821 5.20696 9.87291 5.33974 9.87407C5.47252 9.87522 5.60374 9.90281 5.72575 9.95521C5.84775 10.0076 5.9581 10.0838 6.05034 10.1793L9.11434 13.2433L15.9497 6.40732C16.0425 6.31439 16.1528 6.24067 16.2742 6.19038C16.3955 6.14008 16.5256 6.1142 16.657 6.1142C16.7884 6.1142 16.9185 6.14008 17.0398 6.19038C17.1612 6.24067 17.2715 6.31439 17.3643 6.40732Z" fill="black" />
          </g>
          <defs>
            <filter id="filter0_i_3405_4872" x="0" y="0" width="22" height="26" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
              <feFlood floodOpacity="0" result="BackgroundImageFix" />
              <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
              <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
              <feOffset dy="4" />
              <feGaussianBlur stdDeviation="2" />
              <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
              <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
              <feBlend mode="normal" in2="shape" result="effect1_innerShadow_3405_4872" />
            </filter>
            <clipPath id="clip0_3405_4872">
              <rect width="16" height="16" fill="white" transform="translate(3 3)" />
            </clipPath>
          </defs>
        </svg>
        <svg className={css.notChecked} width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M0 2C0 0.89543 0.895431 0 2 0H20C21.1046 0 22 0.895431 22 2V20C22 21.1046 21.1046 22 20 22H2C0.89543 22 0 21.1046 0 20V2Z" fill="white" />
          <path d="M0.75 2C0.75 1.30964 1.30964 0.75 2 0.75H20C20.6904 0.75 21.25 1.30964 21.25 2V20C21.25 20.6904 20.6904 21.25 20 21.25H2C1.30964 21.25 0.75 20.6904 0.75 20V2Z" stroke="black" strokeOpacity="0.6" strokeWidth="1.5" />
        </svg>
      </div> : (
        <svg className={props.className} width="14" height="14" xmlns="http://www.w3.org/2000/svg">
          <circle
            className={props.showAsRequired ? css.required : css.notChecked}
            cx="5"
            cy="19"
            r="6"
            transform="translate(2 -12)"
            strokeWidth="2"
            fill="none"
            fillRule="evenodd"
          />

          <g
            className={classNames(css.checked, checkedClassName || css.checkedStyle)}
            transform="translate(2 -12)"
            fill="none"
            fillRule="evenodd"
          >
            <circle strokeWidth="2" cx="5" cy="19" r="6" />
            <circle fill="#FFF" fillRule="nonzero" cx="5" cy="19" r="3" />
          </g>
        </svg>)}
    </div>
  );
};

IconRadioButton.defaultProps = { className: null };

IconRadioButton.propTypes = { className: string };

const FieldRadioButtonComponent = props => {
  const {
    rootClassName,
    className,
    svgClassName,
    checkedClassName,
    id,
    label,
    showAsRequired,
    isCheckBoxStyle,
    ...rest
  } = props;

  const classes = classNames(rootClassName || css.root, className);
  const radioButtonProps = {
    id,
    className: css.input,
    component: 'input',
    type: 'radio',
    ...rest,
  };

  return (
    <span className={classes}>
      <Field {...radioButtonProps} />
      <label htmlFor={id} className={css.label}>
        <span className={css.radioButtonWrapper}>
          <IconRadioButton
            className={svgClassName}
            checkedClassName={checkedClassName}
            showAsRequired={showAsRequired}
            isCheckBoxStyle={isCheckBoxStyle}
          />
        </span>
        <span className={css.text}>{label}</span>
      </label>
    </span>
  );
};

FieldRadioButtonComponent.defaultProps = {
  className: null,
  rootClassName: null,
  svgClassName: null,
  checkedClassName: null,
  label: null,
};

FieldRadioButtonComponent.propTypes = {
  className: string,
  rootClassName: string,
  svgClassName: string,
  checkedClassName: string,

  // Id is needed to connect the label with input.
  id: string.isRequired,
  label: node,

  // Name groups several RadioButtones to an array of selected values
  name: string.isRequired,

  // RadioButton needs a value that is passed forward when user checks the RadioButton
  value: string.isRequired,
};

export default FieldRadioButtonComponent;
